import React from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import { Button, Icon, Popup } from "semantic-ui-react";

// Botão "Editar" padrão do sistema (azul sólido com lápis). `compacto` mostra só o ícone.
const BotaoEditar = ({ to, compacto, dica, rotulo, ...props }) => (
  <Popup
    content={dica || "Editar"}
    position="top center"
    trigger={
      <Button
        as={Link}
        to={to}
        icon={compacto}
        className="va-btn-acao va-btn-editar"
        aria-label={rotulo || "Editar"}
        {...props}
      >
        <Icon name="pencil" />
        {!compacto && "Editar"}
      </Button>
    }
  />
);

BotaoEditar.propTypes = {
  to: PropTypes.string.isRequired,
  compacto: PropTypes.bool,
  dica: PropTypes.string,
  rotulo: PropTypes.string
};

export default BotaoEditar;
